export default __webpack_public_path__ + "static/media/mobPOSs.29abf6aa.png";